export const handleTime = (value, setSchedule) => {
  // Permitir borrado
  if (value === "") {
    setSchedule(value);
    return;
  }

  // Permitir números solos (hora)
  if (/^\d{0,2}$/.test(value)) {
    setSchedule(value);
    return;
  }

  // Permitir números con dos dígitos y dos puntos (hora:minutos)
  if (/^\d{2}:[0-5]?\d{0,2}$/.test(value)) {
    setSchedule(value);
    return;
  }

  // Validar formato completo HH:MM
  if (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
    setSchedule(value);
  }
};

// Función para normalizar los valores (asegurar que coincidan con nuestras opciones)

export const normalizeValue = (value, options) => {
  if (!value) return "";
  // Buscamos el valor en las opciones (case insensitive y sin acentos)
  const normalizedValue = value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  const foundOption = options.find(
    (opt) =>
      opt.value
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") === normalizedValue
  );
  return foundOption ? foundOption.value : "";
};

export const LEVELS = {
  PRINCIPIANTES: "principiantes",
  INTERMEDIOS: "intermedios",
  AVANZADOS: "avanzados",
};

export const TRAINING_TYPES = {
  RESISTENCIA: "resistencia",
  VELOCIDAD: "velocidad",
  TECNICA: "tecnica",
  FONDOS_LARGOS: "fondos_largos",
};

export const levelsOptions = [
  { value: LEVELS.PRINCIPIANTES, label: "Principiantes" },
  { value: LEVELS.INTERMEDIOS, label: "Intermedios" },
  { value: LEVELS.AVANZADOS, label: "Avanzados" },
];

export const trainingTypesOptions = [
  { value: TRAINING_TYPES.RESISTENCIA, label: "Resistencia" },
  { value: TRAINING_TYPES.VELOCIDAD, label: "Velocidad" },
  { value: TRAINING_TYPES.TECNICA, label: "Técnica" },
  { value: TRAINING_TYPES.FONDOS_LARGOS, label: "Fondos largos" },
];

export const daysOfWeekOptions = [
  { value: "Lunes", label: "Lunes" },
  { value: "Martes", label: "Martes" },
  { value: "Miercoles", label: "Miércoles" },
  { value: "Jueves", label: "Jueves" },
  { value: "Viernes", label: "Viernes" },
  { value: "Sabado", label: "Sábado" },
  { value: "Domingo", label: "Domingo" },
];
